export const IssueIcon: React.FC = () => (
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M12.5 7.5H16.25' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.75 13.75H23.75' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.75 20H23.75' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.75 26.25H23.75' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M13.75 32.5H18.75' stroke='#1F74B6' strokeWidth='2.25' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M32.5 1.25H35C35.663 1.25 36.2989 1.51339 36.7678 1.98223C37.2366 2.45107 37.5 3.08696 37.5 3.75V10.8333C37.5 11.2754 37.3244 11.6993 37.0118 12.0118C36.6993 12.3244 36.2754 12.5 35.8333 12.5H30V3.75C30 3.08696 30.2634 2.45107 30.7322 1.98223C31.2011 1.51339 31.837 1.25 32.5 1.25V1.25Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M33.75 1.25H12.5C11.1739 1.25 9.90215 1.77678 8.96447 2.71447C8.02678 3.65215 7.5 4.92392 7.5 6.25V31.25C7.5 36.25 5 37.71 2.5 38.75H22.5C24.4891 38.75 26.3968 37.9598 27.8033 36.5533C29.2098 35.1468 30 33.2391 30 31.25V12.5'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
